export const permissionCheck = (permission: string, rolePermissions: string[],bypass: boolean = false) => {
    if (bypass) {
        return true;
    }
    return rolePermissions.includes(permission);
};